/** Cookie banner controls the shared regional/GPC consent decision. */
export const getConsentScript = (): string => `
(function () {
  function hasValidPreference() {
    try {
      const p = JSON.parse(localStorage.getItem("cookie-consent") || "null");
      return p && p.hasSetPreference === true && typeof p.analytics === "boolean" &&
        p.expires && new Date(p.expires).getTime() > Date.now();
    } catch (_) { return false; }
  }
  // Show consent banner
  function showConsentBanner(force = false) {
    // Use requestIdleCallback for better performance, fallback to setTimeout
    const scheduleRender = window.requestIdleCallback || function(cb) {
      return setTimeout(cb, 1000);
    };
    
    scheduleRender(() => {
      try {
        if (window.privacyConsent?.gpc && force !== true) return;
        if (document.querySelector(".cookie-consent-banner")) return;
        // Use DocumentFragment to batch DOM operations
        const fragment = document.createDocumentFragment();
        const banner = document.createElement("div");
        banner.className = "cookie-consent-banner";
        banner.setAttribute("role", "dialog");
        banner.setAttribute("aria-label", "Cookie consent");
        banner.setAttribute("aria-modal", "false");
        
        // Header
        const header = document.createElement("div");
        header.className = "cookie-consent-header";
        const title = document.createElement("p");
        title.textContent = "Privacy Preference Center";
        header.appendChild(title);
        
        // Content
        const content = document.createElement("div");
        content.className = "cookie-consent-content";
        const p = document.createElement("p");
        p.textContent = window.privacyConsent?.gpc && !window.privacyConsent?.allowed
          ? "Global Privacy Control is on, so Google Analytics, PostHog, and advertising pixels are off. You can still turn them on with Accept All."
          : "In the EEA, UK, and Switzerland, analytics and advertising stay off until you accept. Elsewhere, Google Analytics and advertising pixels are on by default and PostHog runs without cookies. Accept All lets PostHog use cookies too; Decline turns analytics and advertising off. Essential services remain available.";

        const list = document.createElement("ul");
        list.className = "cookie-consent-list";

        const items = [
          "Essential cookies for security and basic functionality",
          "Analytics to understand site usage",
          "Advertising pixels to measure and provide relevant ads"
        ];
        
        items.forEach(item => {
          const li = document.createElement("li");
          li.textContent = item;
          list.appendChild(li);
        });
        
        const question = document.createElement("p");
        question.className = "cookie-consent-question";
        question.textContent = "Allow analytics cookies and advertising?";
        
        content.appendChild(p);
        content.appendChild(list);
        content.appendChild(question);
        
        // Buttons
        const buttonsDiv = document.createElement("div");
        buttonsDiv.className = "cookie-consent-buttons";
        
        const declineBtn = document.createElement("button");
        declineBtn.className = "cookie-consent-button decline";
        declineBtn.textContent = "Decline All";
        declineBtn.onclick = window.declineCookieConsent;
        
        const acceptBtn = document.createElement("button");
        acceptBtn.className = "cookie-consent-button accept";
        acceptBtn.textContent = "Accept All";
        acceptBtn.onclick = window.acceptCookieConsent;

        buttonsDiv.appendChild(declineBtn);
        buttonsDiv.appendChild(acceptBtn);
        
        banner.appendChild(header);
        banner.appendChild(content);
        banner.appendChild(buttonsDiv);
        fragment.appendChild(banner);
        
        // Single DOM append
        document.body.appendChild(fragment);
        console.log("Consent banner added to DOM");
      } catch (e) {
        console.error("Error adding consent banner:", e);
      }
    });
  }

  function hideBanner() {
    const banner = document.querySelector(".cookie-consent-banner");
    if (banner) banner.remove();
  }
  window.acceptCookieConsent = function () {
    // An explicit Accept overrides GPC (lib/consent/privacy.ts).
    window.privacyConsent?.setPreference(true);
    hideBanner();
  };
  window.declineCookieConsent = function () {
    window.privacyConsent?.setPreference(false);
    hideBanner();
  };
  window.openPrivacyPreferences = function () { showConsentBanner(true); };
  // Ask only visitors whose default is off: the opt-in regions and unknown countries
  // (zee, 2026-11-04: no banner outside the opt-in regions; the footer's Privacy Choices
  // control is the way to change a choice everywhere). Never ask a visitor to undo a GPC
  // opt-out; Accept still works from the footer.
  var asked = false;
  function askIfRequired() {
    var p = window.privacyConsent;
    if (asked || !p || !p.ready || p.gpc || hasValidPreference()) return;
    if ((p.source === "region" || p.source === "unknown") && !p.allowed) {
      asked = true;
      showConsentBanner();
    }
  }
  askIfRequired();
  window.addEventListener("consent_update", askIfRequired);
})();
`;

export const CONSENT_SCRIPT = getConsentScript();
